import React from 'react';
import Loadable from 'react-loadable';

const NLdoetProjectLazy = Loadable({
  loader: () => import('./index.lazy'),
  loading: () => (<div />),
});

export default NLdoetProjectLazy;
